import { observer } from 'mobx-react';
import Select from 'react-select';
import { Link } from '../../../../../../../../../Resource/Types';
import Label from '../../../../../../../../Form/Label';
import ErrorMessage from './ErrorMessage';
import FormattedOptionLabel from './FormattedOptionLabel';
import NoOptionsMessage from './NoOptionsMessage';
import { options, selectedValue } from './UseGroupDynamicTypeaheadSelect/Computeds';
import { stylesConfig } from './Styles';
import { FilterOption } from './UseGroupDynamicTypeaheadSelect/Types';
import { useGroupDynamicTypeaheadSelect } from './UseGroupDynamicTypeaheadSelect';

export interface Props {
  endpoint: Link;
  onChange: (value: FilterOption) => void;
}

function GroupDynamicTypeaheadSelect({ endpoint, onChange }: Props) {
  const { state, handleInputChange, handleSelectionChange } = useGroupDynamicTypeaheadSelect(
    endpoint,
    onChange,
  );

  switch (state.kind) {
    case 'error':
      return <ErrorMessage message={state.message} />;
    case 'filtered':
    case 'filtering':
    case 'option-selected':
    case 'ready':
      return (
        <div className="min-w-[200px]">
          <Label htmlFor={'group'} labelText={'Group'} className="font-medium text-sm" />
          <Select
            autoFocus
            className="mt-2"
            formatOptionLabel={(filterOption) => (
              <FormattedOptionLabel filterOption={filterOption} />
            )}
            name={'group'}
            inputId={'group'}
            value={selectedValue(state)}
            styles={stylesConfig}
            options={options(state)}
            onChange={handleSelectionChange}
            isSearchable
            placeholder={'Type to search...'}
            onInputChange={handleInputChange}
            filterOption={() => true}
            components={{
              DropdownIndicator: () => null,
              IndicatorSeparator: () => null,
            }}
            menuPortalTarget={document.body}
            noOptionsMessage={({ inputValue }) => (
              <NoOptionsMessage inputValue={inputValue} state={state} />
            )}
          />
        </div>
      );
  }
}

export default observer(GroupDynamicTypeaheadSelect);
